import { Helmet } from "react-helmet-async";
import './contact.css';
import Navbar from "../../components/navbar/navbar";

const Contact = () => {
    return(
        <>
            <Helmet>
                <title>Contact a Handyman in Melbourne | Get a Quote</title>
                <meta name="description" content="Contact Handyman In Melbourne to book home repairs, installations or commercial maintenance. Call 0412 279 273 to discuss your job and request a quote." />
                <link rel="canonical" href="https://handymaninmelbourne.au/contact" />
            </Helmet>

            <a className="skip-link" href="#main-content">Skip to main content</a>
            <Navbar />

            {/* Hero Section */}
            <main id="main-content">
            <section className="contact-hero">
                <div className="hero-content">
                <h1 className="hero-content-h1">Contact Your Local Handyman</h1>
                <p className="contact-tagline">Quick response • Reliable local service • Fixed price quotes</p>
                <a href="tel:0412279273" className="btn-phone">
                    📞 0412 279 273
                </a>
                </div>
            </section>

            <div className="content-container">
                <div className="content-grid">
                    {/* Main Form */}
                    <div className="form-card">
                        <h2 className="form-card-h2">Send Us Your Job Details</h2>
                        <p className="form-intro">The more information you provide, the faster and more accurate your quote will be.</p>

                        <form 
                            action="https://formspree.io/f/mlgejwwd"
                            method="POST"
                            className="form"
                        >
                            <div className="form-inner">
                                <div className="form-row">
                                    <label>Name<input className="form-input" type="text" name="name" autoComplete="name" pattern="[A-Za-z\s\-']{2,50}" required /></label>
                                    <label>Phone<input className="form-input" type="tel" name="phone" autoComplete="tel" pattern="04[0-9]{8}" required /></label>
                                </div>
                                
                                <div className="form-row">
                                    <label>Email<input className="form-input" type="email" name="email" autoComplete="email" required /></label>
                                    <label>Suburb<input className="form-input" type="text" name="suburb" autoComplete="address-level2" pattern="[A-Za-z\s\-']{2,30}" required /></label>
                                </div>

                                <div className="form-row message-row">
                                    <label htmlFor="contact-message">Describe your job
                                        <textarea className="form-textarea" id="contact-message" name="message" />
                                    </label>
                                </div>
                                
                                <button className="btn-submit" type="submit">Get Your Free Quote</button>
                            </div>
                            
                        </form>
                    </div>

                    {/* Sidebar Info */}
                    <div className="sidebar">
                        <h3>Why Contact Us?</h3>
                        <ul className="benefits-list">
                        <li>Same-week response in most cases</li>
                        <li>Fixed price quotes, no hidden fees</li>
                        <li>Trusted local tradesperson</li>
                        <li>Fully insured &amp; police checked</li>
                        </ul>

                        <div className="contact-info">
                        <h3>Direct Contact</h3>
                        <div className="info-row">
                            📞 <a href="tel:0412279273"><strong>0412 279 273</strong></a>
                        </div>
                        <div className="info-row">
                            ✉️ <a href="mailto:info@handymaninmelbourne.au">info@handymaninmelbourne.au</a>
                        </div>
                        <div className="info-row">
                            📍 &nbsp; Serving most Melbourne suburbs
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            </main>
      </>
    )
}

export default Contact;
